export const AuthMap = {
    LOGIN_START: 'LOGIN_START',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_ERROR: 'LOGIN_ERROR',

    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',

    FORGOT_PASSWORD_START: 'FORGOT_PASSWORD_START',
    FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
    FORGOT_PASSWORD_ERROR: 'FORGOT_PASSWORD_ERROR',

    SET_NEW_PASSWORD_START: 'SET_NEW_PASSWORD_START',
    SET_NEW_PASSWORD_SUCCESS: 'SET_NEW_PASSWORD_SUCCESS',
    SET_NEW_PASSWORD_ERROR: 'SET_NEW_PASSWORD_ERROR',

    RESEND_CODE_START: 'RESEND_CODE_START',
    RESEND_CODE_SUCCESS: 'RESEND_CODE_SUCCESS',
    RESEND_CODE_ERROR: 'RESEND_CODE_ERROR',

    USER_REGISTER_START: 'USER_REGISTER_START',
    USER_REGISTER_SUCCESS: 'USER_REGISTER_SUCCESS',
    USER_REGISTER_ERROR: 'USER_REGISTER_ERROR',

    USER_REGISTER_VERIFICATION_START: 'USER_REGISTER_VERIFICATION_START',
    USER_REGISTER_VERIFICATION_SUCCESS: 'USER_REGISTER_VERIFICATION_SUCCESS',
    USER_REGISTER_VERIFICATION_ERROR: 'USER_REGISTER_VERIFICATION_ERROR',

    USER_LOGIN_VERIFICATION_START: 'USER_LOGIN_VERIFICATION_START',
    USER_LOGIN_VERIFICATION_SUCCESS: 'USER_LOGIN_VERIFICATION_SUCCESS',
    USER_LOGIN_VERIFICATION_ERROR: 'USER_LOGIN_VERIFICATION_ERROR',

    USER_LOGOUT_START: 'USER_LOGOUT_START',
    USER_LOGOUT_SUCCESS: 'USER_LOGOUT_SUCCESS',
    USER_LOGOUT_ERROR: 'USER_LOGOUT_ERROR',

    REDIRECT_REGISTER_VERIFICATION: 'REDIRECT_REGISTER_VERIFICATION',

    USER_BASIC_INFORMATION_START: 'USER_BASIC_INFORMATION_START',
    USER_BASIC_INFORMATION_SUCCESS: 'USER_BASIC_INFORMATION_SUCCESS',
    USER_BASIC_INFORMATION_ERROR: 'USER_BASIC_INFORMATION_ERROR',


   PHONE_EMAIL_OTP_START: 'PHONE_EMAIL_OTP_START',
   PHONE_EMAIL_OTP_SUCCESS: 'PHONE_EMAIL_OTP_SUCCESS',
   PHONE_EMAIL_OTP_ERROR: 'PHONE_EMAIL_OTP_ERROR',

   WALLETADDRESS_START: 'WALLETADDRESS_START',
   WALLETADDRESS_SUCCESS: 'WALLETADDRESS_SUCCESS',
   WALLETADDRESS_ERROR: 'WALLETADDRESS_ERROR',


    RESET_INIT_AUTH_STATE: 'RESET_INIT_AUTH_STATE',

    UPLOAD_PROFILE_IMAGE_START: 'UPLOAD_PROFILE_IMAGE_START',
    UPLOAD_PROFILE_IMAGE_SUCCESS: 'UPLOAD_PROFILE_IMAGE_SUCCESS',
    UPLOAD_PROFILE_IMAGE_ERROR: 'UPLOAD_PROFILE_IMAGE_ERROR',

    CONTACT_US_START: 'CONTACT_US_START',
    CONTACT_US_SUCCESS: 'CONTACT_US_SUCCESS',
    CONTACT_US_ERROR: 'CONTACT_US_ERROR',

    GET_ALL_CMS_PAGES_START: 'GET_ALL_CMS_PAGES_START',
    GET_ALL_CMS_PAGES_SUCCESS: 'GET_ALL_CMS_PAGES_SUCCESS',
    GET_ALL_CMS_PAGES_ERROR: 'GET_ALL_CMS_PAGES_ERROR',

    GET_CMS_DETAILS_START: 'GET_CMS_DETAILS_START',
    GET_CMS_DETAILS_SUCCESS: 'GET_CMS_DETAILS_SUCCESS',
    GET_CMS_DETAILS_ERROR: 'GET_CMS_DETAILS_ERROR',

    VERIFY_AUTH_TOKEN_START: 'VERIFY_AUTH_TOKEN_START',
    VERIFY_AUTH_TOKEN_SUCCESS: 'VERIFY_AUTH_TOKEN_SUCCESS',
    VERIFY_AUTH_TOKEN_ERROR: 'VERIFY_AUTH_TOKEN_ERROR',

    UPLOAD_DOCUMENT_START: 'UPLOAD_DOCUMENT_START',
    UPLOAD_DOCUMENT_SUCCESS: 'UPLOAD_DOCUMENT_SUCCESS',
    UPLOAD_DOCUMENT_ERROR: 'UPLOAD_DOCUMENT_ERROR',

    TOGGLE_UPLOAD_DOCUMENT_MODAL: 'TOGGLE_UPLOAD_DOCUMENT_MODAL',

    GET_PROFILE_DASHBOARD_START: 'GET_PROFILE_DASHBOARD_START',
    GET_PROFILE_DASHBOARD_SUCCESS: 'GET_PROFILE_DASHBOARD_SUCCESS',
    GET_PROFILE_DASHBOARD_ERROR: 'GET_PROFILE_DASHBOARD_ERROR',

    USER_OTP_VERIFICATION_START: 'USER_OTP_VERIFICATION_START',
    VERIFY_OTP_SUCCESS: 'VERIFY_OTP_SUCCESS',
    VERIFY_OTP_ERROR: 'VERIFY_OTP_ERROR',

    GET_EMISSTION_DETAILS_START: 'GET_EMISSTION_DETAILS_START',
    GET_EMISSTION_DETAILS_SUCCESS: 'GET_EMISSTION_DETAILS_SUCCESS',
    GET_EMISSTION_DETAILS_ERROR: 'GET_EMISSTION_DETAILS_ERROR',
}

export const AuthActions = {
    loginStart: (data) => ({ type: AuthMap.LOGIN_START, payload: data }),
    loginSuccess: (data) => ({ type: AuthMap.LOGIN_SUCCESS, payload: data }),
    loginError: (errors) => ({ type: AuthMap.LOGIN_ERROR, payload: errors }),

    userRegisterStart: () => ({ type: AuthMap.USER_REGISTER_START }),
    userRegisterSuccess: (data) => ({ type: AuthMap.USER_REGISTER_SUCCESS, payload: data }),
    userRegisterError: (data) => ({ type: AuthMap.USER_REGISTER_ERROR, payload: data }),

    userRegisterVerificationStart: () => ({ type: AuthMap.USER_REGISTER_VERIFICATION_START }),
    userRegisterVerificationSuccess: (data) => ({ type: AuthMap.USER_REGISTER_VERIFICATION_SUCCESS, payload: data }),
    userRegisterVerificationError: (data) => ({ type: AuthMap.USER_REGISTER_VERIFICATION_ERROR, payload: data }),

    userLoginVerificationStart: () => ({ type: AuthMap.USER_LOGIN_VERIFICATION_START }),
    userLoginVerificationSuccess: (data) => ({ type: AuthMap.USER_LOGIN_VERIFICATION_SUCCESS, payload: data }),
    userLoginVerificationError: (data) => ({ type: AuthMap.USER_LOGIN_VERIFICATION_ERROR, payload: data }),

    resendCodeStart: () => ({ type: AuthMap.RESEND_CODE_START }),    
    resendCodeSuccess: () => ({ type: AuthMap.RESEND_CODE_SUCCESS}),
    resendCodeError: () => ({ type: AuthMap.RESEND_CODE_ERROR}),
    
    userLogoutStart: () => ({ type: AuthMap.USER_LOGOUT_START }),
    userLogoutSuccess: () => ({ type: AuthMap.USER_LOGOUT_SUCCESS }),
    userLogoutError: () => ({ type: AuthMap.USER_LOGOUT_ERROR }),

    redirectRegisterValidation: (data) => ({ type: AuthMap.REDIRECT_REGISTER_VERIFICATION, payload: data }),

    uploadProfileImageStart: () => ({ type: AuthMap.UPLOAD_PROFILE_IMAGE_START }),
    uploadProfileImageSuccess: (data) => ({ type: AuthMap.UPLOAD_PROFILE_IMAGE_SUCCESS, payload: data }),
    uploadProfileImageError: () => ({ type: AuthMap.UPLOAD_PROFILE_IMAGE_ERROR }),

    userBasicInformationStart: () => ({ type: AuthMap.USER_BASIC_INFORMATION_START }),
    userBasicInformationSuccess: (data) => ({ type: AuthMap.USER_BASIC_INFORMATION_SUCCESS, payload: data }),
    userBasicInformationError: (data) => ({ type: AuthMap.USER_BASIC_INFORMATION_ERROR, payload: data }),

    phoneEmailOtpStart: () => ({ type: AuthMap.PHONE_EMAIL_OTP_START }),
    phoneEmailOtpSuccess: (data) => ({ type: AuthMap.PHONE_EMAIL_OTP_SUCCESS, payload: data }),
    phoneEmailOtpError: () => ({ type: AuthMap.PHONE_EMAIL_OTP_ERROR}),

    walletAddressStart: () => ({ type: AuthMap.WALLETADDRESS_START }),
    walletAddressSuccess: (data) => ({ type: AuthMap.WALLETADDRESS_SUCCESS, payload: data }),
    walletAddressError: (data) => ({ type: AuthMap.WALLETADDRESS_ERROR,payload:data}),


    resetAuthInitState: () => ({ type: AuthMap.RESET_INIT_AUTH_STATE }),

    forgotPasswordStart: (email) => ({ type: AuthMap.FORGOT_PASSWORD_START, payload: email }),
    forgotPasswordSuccess: (data) => ({ type: AuthMap.FORGOT_PASSWORD_SUCCESS, payload: data }),
    forgotPasswordError: (errors) => ({ type: AuthMap.FORGOT_PASSWORD_ERROR, payload: { errors } }),

    setNewPasswordStart: (data) => ({ type: AuthMap.SET_NEW_PASSWORD_START, payload: data }),
    setNewPasswordSuccess: (data) => ({ type: AuthMap.SET_NEW_PASSWORD_SUCCESS, payload: data }),
    setNewPasswordError: (errors) => ({ type: AuthMap.SET_NEW_PASSWORD_ERROR, payload: { errors } }),

    contactUsStart: (data) => ({ type: AuthMap.CONTACT_US_START, payload: data }),
    contactUsSuccess: (data) => ({ type: AuthMap.CONTACT_US_SUCCESS, payload: data }),
    contactUsError: (errors) => ({ type: AuthMap.CONTACT_US_ERROR, payload: { errors } }),

    getAllCMSPagesStart: (data) => ({ type: AuthMap.GET_ALL_CMS_PAGES_START, payload: data }),
    getAllCMSPagesSuccess: (data) => ({ type: AuthMap.GET_ALL_CMS_PAGES_SUCCESS, payload: data }),
    getAllCMSPagesError: (errors) => ({ type: AuthMap.GET_ALL_CMS_PAGES_ERROR, payload: { errors } }),

    getCMSDetailsStart: (data) => ({ type: AuthMap.GET_CMS_DETAILS_START, payload: data }),
    getCMSDetailsSuccess: (data) => ({ type: AuthMap.GET_CMS_DETAILS_SUCCESS, payload: data }),
    getCMSDetailsError: (errors) => ({ type: AuthMap.GET_CMS_DETAILS_ERROR, payload: { errors } }),

    verifyAuthTokenStart: () => ({ type: AuthMap.VERIFY_AUTH_TOKEN_START }),
    verifyAuthTokenSuccess: (data) => ({ type: AuthMap.VERIFY_AUTH_TOKEN_SUCCESS, payload: data }),
    verifyAuthTokenError: (err) => ({ type: AuthMap.VERIFY_AUTH_TOKEN_ERROR, payload: err }),
    
    uploadDocumentStart: (data) => ({ type: AuthMap.UPLOAD_DOCUMENT_START, payload: data }),
    uploadDocumentSuccess: (data) => ({ type: AuthMap.UPLOAD_DOCUMENT_SUCCESS, payload: data }),
    uploadDocumentError: () => ({ type: AuthMap.UPLOAD_DOCUMENT_ERROR }),

    toggleUploadDocumentModal: (data) => ({type: AuthMap.TOGGLE_UPLOAD_DOCUMENT_MODAL, payload: data}),

    getProfileDashboardStart: (data) => ({ type: AuthMap.GET_PROFILE_DASHBOARD_START, payload: data }),
    getProfileDashboardSuccess: (data) => ({ type: AuthMap.GET_PROFILE_DASHBOARD_SUCCESS, payload: data }),
    getProfileDashboardError: (errors) => ({ type: AuthMap.GET_PROFILE_DASHBOARD_ERROR, payload: { errors } }),

    userOtpVerificationStart: () => ({ type: AuthMap.USER_OTP_VERIFICATION_START }),
    verifyOtpSuccess: (data) => ({ type: AuthMap.VERIFY_OTP_SUCCESS, payload: data}),
    verifyOtpError: (errors) => ({ type: AuthMap.VERIFY_OTP_ERROR }),

    getEmissionDetailsStart: (data) => ({type: AuthMap.GET_EMISSTION_DETAILS_START, payload: data}),
    getEmissionDetailsSuccess: (data) => ({type: AuthMap.GET_EMISSTION_DETAILS_SUCCESS, payload: data}),
    getEmissionDetailsError: (errors) => ({type: AuthMap.GET_EMISSTION_DETAILS_ERROR, payload: {errors}}),
} 